import { defineStore } from 'pinia';
import type { FatalError, FatalErrorSolution } from '@/types/errorTypes.ts';
import { computed, ref } from 'vue';

export const useErrorsStore = defineStore('errors', () => {
  // States
  const fatalErrors = ref<FatalError[]>([]);

  // Getters
  const hasFatalError = computed(() => fatalErrors.value.length > 0);
  const nextFatalError = computed(() => (hasFatalError.value ? fatalErrors.value[0] : undefined));

  // Actions
  function clearErrors() {
    fatalErrors.value = [];
  }

  function addFatalError(payload: { name: string; filename?: string; message: string; solution?: FatalErrorSolution }) {
    const error: FatalError = {
      id: fatalErrors.value.length > 0 ? Math.max(...fatalErrors.value.map((e) => e.id)) + 1 : 0,
      name: payload.name,
      filename: payload.filename,
      message: payload.message,
      solution: payload.solution,
    };

    fatalErrors.value.push(error);
  }

  function removeFatalError(errorId: number) {
    const idx = fatalErrors.value.findIndex((e) => e.id === errorId);
    if (idx !== -1) {
      fatalErrors.value.splice(idx, 1);
    }
  }

  return {
    nextFatalError,
    hasFatalError,
    addFatalError,
    removeFatalError,
    clearErrors,
  };
});

export default useErrorsStore;
